
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/page/[index]",
      function () {
        return require("private-next-pages/page/[index].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/page/[index]"])
      });
    }
  